var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgD1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.573 2.8999C50.67 17.3599 43.848 33.3019 43.848 33.3019C43.848 33.3019 49.848 40.1299 47.422 46.0999C47.422 46.0999 44.947 41.9199 40.798 41.9199C36.797 41.9199 34.448 46.0999 26.398 46.0999C8.474 46.0999 0 31.0099 0 31.0099C16.147 41.7159 27.173 34.1339 27.173 34.1339C19.898 29.8779 4.423 9.5239 4.423 9.5239C17.899 21.0859 23.724 24.1339 23.724 24.1339C20.249 21.2379 10.498 7.0819 10.498 7.0819C18.298 15.0419 33.797 26.1489 33.797 26.1489C38.198 13.8569 29.573 2.8999 29.573 2.8999Z",
    fill: "#DD574A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD1);
export default __webpack_public_path__ + "static/media/d1.6e03016edaa009f0dfda9dc26b8359b3.svg";
export { ForwardRef as ReactComponent };